import { ILocationResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceSort,
} from 'custom_hooks/data_hooks/data_source/data_source';
import { useInfiniteDataSource } from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import { buildOrderBy, Filter, toDataSourceResult } from 'utils/query_v3';

export type LocationsFilter = Readonly<{
    name?: string;
    corporationId?: string;
}>;

export type InfiniteLocationDataSourceOptions = BaseDataSourceOptions<
    ILocationResponse,
    LocationsFilter
>;

export const infiniteLocationsDataSourceKey = 'get-infinite-locations';

export const sortByName: DataSourceSort[] = [{ field: 'Name', dir: 'asc' }];
export const sortByCorporation: DataSourceSort[] = [
    { field: 'CorporationName', dir: 'asc' },
    { field: 'Name', dir: 'asc' },
];

export function useInfiniteLocationDataSource(
    options: InfiniteLocationDataSourceOptions
) {
    return useInfiniteDataSource({
        ...options,
        query: ({ filter, sort, page, pageLimit }) => {
            const orderBy = buildOrderBy(sort);

            const filterExpr = Filter.and(
                Filter.eq('Active', true),
                filter.corporationId
                    ? Filter.eq('CorporationId', filter.corporationId)
                    : undefined
            );

            return toDataSourceResult(
                sdClient.getLocations({
                    filter: filterExpr,
                    page,
                    pageLimit,
                    orderBy,
                    nameSearch: filter.name,
                })
            );
        },
    });
}
